import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.5_@babel+core@7.29.7_acb4625394aa3638cacfe6c4008e1f28/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocumentLanguage"] */ "/app/src/i18n/document-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogAdminRouteGate"] */ "/app/src/lib/posthog-admin-route-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageviewTracker"] */ "/app/src/lib/posthog-pageview-tracker.tsx");
